import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { TreeService } from 'src/app/services/Tree/tree.service';
import { MediaTree, FolderNode, FileNode } from 'src/app/utils/common-classes';
import { UtilsService } from 'src/app/services/Utils/utils.service';
import { FolderDataSource } from 'src/app/utils/dynamic-tree-classes';
import { FolderService } from 'src/app/services/Folder/folder.service';

@Component({
  selector: 'app-move-tree',
  templateUrl: './folder-move-tree.component.html',
  styleUrls: ['./folder-move-tree.component.scss']
})
export class FolderMoveTreeComponent implements OnInit {
  @Input()
  mediaTree: MediaTree;
  @Input()
  node: FolderNode;
  @Input()
  files: Array<FileNode>;

  @Output()
  selectFolder = new EventEmitter<FolderNode>();
  test: boolean = true;

  treeControl: FlatTreeControl<FolderNode>;
  dataSource: FolderDataSource;

  selectedFolder: FolderNode;
  emptyNode: FolderNode;

  constructor(private treeService: TreeService,
    public utils: UtilsService,
    private folderService: FolderService) {
  }

  ngOnInit() {
    this.treeControl = new FlatTreeControl<FolderNode>(this.getLevel, this.isExpandable);
    this.dataSource = new FolderDataSource(this.treeControl, this.mediaTree.mediaTreeId, this.utils, this.folderService);
    this.emptyNode = new FolderNode();
    this.emptyNode.name = this.mediaTree.name;
  }

  private getLevel(node: FolderNode): number {
    return node.level;
  };

  private isExpandable(node: FolderNode): boolean {
    return node.expandable;
  };

  public hasChild(_: number, _nodeData: FolderNode): boolean {
    return _nodeData.expandable;
  };

  public folderClick(node: FolderNode): void {
    let _self = this;
    if (_self.isValidFolder(node)) {
      this.selectedFolder = node;
      this.selectFolder.emit(node);
    }
  }

  public isValidFolder(node: FolderNode): boolean {
    let _self = this;
    if (_self.files && _self.files.length > 0) {
      return node.mediaFolderId != _self.node.mediaFolderId && node.mediaFolderId != null;
    }
    return (!_self.dataSource.isChildren(_self.node, node) && node.mediaFolderId != _self.node.parentFolderId);
  }

}